import { render, staticRenderFns } from "./ExamReview.vue?vue&type=template&id=a1a332aa&scoped=true&"
import script from "./ExamReview.vue?vue&type=script&lang=js&"
export * from "./ExamReview.vue?vue&type=script&lang=js&"
import style0 from "./ExamReview.vue?vue&type=style&index=0&id=a1a332aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a332aa",
  null
  
)

export default component.exports